import { useScrollReveal } from '@/hooks/useScrollReveal';

const updates = [
  {
    date: '07-28',
    title: '《深渊之触》第 187 话更新',
    desc: '探险队深入海底遗迹，新的触手生物形态首次登场，剧情迎来重大转折。',
    tag: '热门',
  },
  {
    date: '07-27',
    title: '《暗影使徒》第 95 话更新',
    desc: '主角觉醒全新能力形态，暗影触手的操控精度大幅提升。',
  },
  {
    date: '07-26',
    title: '新作《星域触手姬》首话上线',
    desc: '全新触手题材科幻漫画正式开载，首话三连更精彩不容错过。',
    tag: '新作',
  },
  {
    date: '07-25',
    title: '《异种学院》第 203 话更新',
    desc: '学院最终试炼篇开启，多位角色迎来关键成长时刻。',
    tag: '推荐',
  },
  {
    date: '07-24',
    title: '《触手纪元》全集精校版上线',
    desc: '经典完结作品全面精校重制，阅读体验大幅提升，全 312 话免费畅读。',
  },
  {
    date: '07-23',
    title: '《星海迷踪》第 148 话更新',
    desc: '星际探险队首次与触手文明面对面交流，悬念迭起的篇章就此展开。',
  },
  {
    date: '07-22',
    title: '触手漫画专题推荐：夏日必读',
    desc: '编辑团队精选 10 部适合夏日阅读的触手题材漫画，清凉与刺激并存。',
    tag: '专题',
  },
];

export default function UpdatesSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="updates" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/60 border border-accent-200/50 mb-4">
            <i className="ri-timer-flash-line text-accent-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">每日实时追踪</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            更新动态
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画每日最新更新，追更不等待
          </p>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updates.map((item, idx) => (
            <UpdateItem key={idx} item={item} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function UpdateItem({ item, idx }: { item: typeof updates[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <div
      ref={ref}
      className={`relative mb-10 last:mb-0 ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <div className="absolute -left-[calc(2rem+5px)] md:-left-[calc(2.5rem+5px)] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
      <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
        <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded whitespace-nowrap w-fit">
          {item.date}
        </span>
        <div className="flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
            {item.tag && (
              <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                {item.tag}
              </span>
            )}
          </div>
          <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">{item.desc}</p>
        </div>
      </div>
    </div>
  );
}